<template>
  <div class="calendar-container">
    <div class="calendar-heading">
      <div class="calendar-heading-button-group">
        <round-button-with-icon
          class="icon"
          @click="yearChange(`backward`)"
          icon="left-arrow-double"
        />
        <round-button-with-icon
          class="icon"
          @click="monthChange(`backward`)"
          icon="left-arrow-single"
        />
      </div>
      <h5 class="month-heading">
        {{ monthArray[viewedMonth.getMonth()] }},
        {{ viewedMonth.getFullYear() }}
      </h5>
      <div class="calendar-heading-button-group">
        <round-button-with-icon
          class="icon"
          icon="right-arrow-single"
          @click="monthChange(`forward`)"
        />
        <round-button-with-icon
          class="icon"
          icon="right-arrow-double"
          @click="yearChange(`forward`)"
        />
      </div>
    </div>
    <div class="main-calendar-content">
      <div v-for="(day, index) in WEEKDAYS" class="weekday" :key="index">
        {{ day }}
      </div>
      <div
        v-for="(day, index) in days"
        :key="index"
        :class="{
          day,
          isNotCurrentMonth: !day.isCurrentMonth,
          today: day.isCurrentDay,
          hasEvents: day.hasEvents,
        }"
      >
        <p>{{ day.dayOfMonth }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import RoundButtonWithIcon from "../UI/RoundButtonWithIcon.vue";
import {
  nextMonthDays,
  previousMonthDays,
  currentMonthDays,
} from "../../Helpers/calendar.js";

export default {
  data() {
    return {
      WEEKDAYS: ["S", "M", "T", "W", "T", "F", "S"],
      monthArray: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ],
      floatingMenuOpen: false,
      singleDayChosen: undefined,
      month: new Date().getMonth(),
      year: new Date().getFullYear(),
    };
  },

  methods: {
    monthChange(direction) {
      if (direction == `forward`) {
        this.month++;
      }
      if (direction == `backward`) {
        this.month--;
      }
      this.$emit("month-change", this.month);
    },
    yearChange(direction) {
      if (direction == `forward`) {
        this.year++;
      }
      if (direction == `backward`) {
        this.year--;
      }
      this.$emit("year-change", this.year);
    },
  },
  computed: {
    viewedMonth() {
      return new Date(this.year, this.month);
    },
    surroundingYears() {
      let array = [];
      for (
        let temporaryYear = this.year - 3;
        temporaryYear < this.year + 7;
        temporaryYear++
      ) {
        array.push(temporaryYear);
      }
      return array;
    },
    floatingIconActions() {
      return {
        left: this.surroundingYears,
        right: this.monthArray,
      };
    },
    daysWithEvents() {
      return this.events.map((a) => {
        switch (a.api_version) {
          case "9-28-2022":
            return new Date(a.date);
          default:
            return new Date(a.data.date);
        }
      });
    },
    currentMonthDays() {
      let eventDays = this.daysWithEvents;
      return currentMonthDays(this.viewedMonth).map((x) => {
        return {
          ...x,
          get hasEvents() {
            return eventDays.some((x) => {
              return x.toDateString() == this.date.toDateString();
            });
          },
        };
      });
    },
    days() {
      return [
        ...previousMonthDays(this.viewedMonth),
        ...this.currentMonthDays,
        ...nextMonthDays(this.viewedMonth),
      ];
    },
  },
  emits: ["actionsClicked", "month-change", "year-change"],
  props: ["events"],
  components: {
    RoundButtonWithIcon,
  },
};
</script>

<style scoped>
@media screen {
  .calendar-container {
    display: flex;
    flex-direction: column;
  }

  .calendar-heading {
    display: flex;
    justify-content: space-between;
  }

  .calendar-heading-button-group {
    display: flex;
    align-items: center;
  }
  .main-calendar-content {
    width: 100%;
    flex: 1;
    display: grid;
    align-content: space-between;
    justify-content: space-between;
    grid-template-columns: repeat(7, 45px);
    grid-template-rows: repeat(auto-fill, 45px);
    cursor: default;
  }

  .main-calendar-content div {
    /* flex: 1; */
    font-size: 12px;
    /* margin: auto; */
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .hasEvents {
    background: radial-gradient(
      circle at center,
      var(--accentColor) 0%,
      var(--accentColor) 40%,
      var(--contrastColor) 43%,
      rgba(0, 0, 0, 0) 44%
    );
    cursor: pointer;
  }

  .isNotCurrentMonth {
    opacity: 0.25;
  }

  .text > svg {
    cursor: pointer;
  }

  .icon {
    margin: 10px;
  }

  .today {
    background: radial-gradient(
      circle at center,
      var(--contrastColor) 0%,
      var(--contrastColor) 43%,
      rgba(0, 0, 0, 0) 44%
    );
  }

  .today > * {
    filter: invert(100%);
  }
  @media (min-width: 800px) {
    .calendar-container {
      display: flex;
      flex-direction: column;
    }

    .calendar-heading {
      display: flex;
      justify-content: space-between;
    }

    .calendar-heading-button-group {
      display: flex;
      align-items: center;
    }
    .main-calendar-content {
      width: 100%;
      flex: 1;
      display: grid;
      align-content: space-between;
      justify-content: space-between;
      grid-template-columns: repeat(7, 50px);
      grid-template-rows: repeat(auto-fill, 60px);
      cursor: default;
    }

    .main-calendar-content div {
      /* flex: 1; */
      font-size: 12px;
      /* margin: auto; */
      font-weight: 700;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .hasEvents {
      background: radial-gradient(
        circle at center,
        var(--accentColor) 0%,
        var(--accentColor) 40%,
        var(--contrastColor) 43%,
        rgba(0, 0, 0, 0) 44%
      );
      cursor: pointer;
    }

    .isNotCurrentMonth {
      opacity: 0.25;
    }

    .text > svg {
      cursor: pointer;
    }

    .icon {
      margin: 10px;
    }

    .today {
      background: radial-gradient(
        circle at center,
        var(--contrastColor) 0%,
        var(--contrastColor) 43%,
        rgba(0, 0, 0, 0) 44%
      );
    }

    .today > * {
      filter: invert(100%);
    }
  }
}
</style>
